import { render } from "./infoOfVacancies.vue?vue&type=template&id=31eea1d6"
import script from "./infoOfVacancies.vue?vue&type=script&lang=js"
export * from "./infoOfVacancies.vue?vue&type=script&lang=js"

import "./infoOfVacancies.vue?vue&type=style&index=0&id=31eea1d6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__